import React from "react";
import { Box, Container, Grid, Modal, Typography } from "@mui/material";
import { ModalHeader } from "../../common/modalHeader";
import QrCode2Icon from '@mui/icons-material/QrCode2';

function DisplayQrScanModal({ open, setOpen, onClose }) {

    return (
      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "40%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "95%", sm: "60%", md: "50%", lg: "40%" },

            bgcolor: "background.paper",
            borderRadius: "10px",
            boxShadow: 24,
          }}
        >
          <ModalHeader title={"Scan QR code to pay by UPI"} onClose={onClose} />

          <Box>
            <Grid
              container
              spacing={2}
              sx={{
                paddingTop: "20px",
                paddingLeft: "16px",
                paddingRight: "0 !important",
              }}
            >
              <Grid item xs={4}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "top",
                    height: "100%",
                  }}
                >
                  <QrCode2Icon sx={{ fontSize: 120, color: "primary.main" }} />
                </Box>
              </Grid>
              <Grid item xs={8}>
                <Typography
                  sx={{
                    mb: 2,
                  }}
                >
                  <Typography
                    component="span"
                    sx={{ marginRight: "10px", fontWeight: 500 }}
                  >
                    Merchant Name:
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontWeight: 600, color: "#000" }}
                  >
                    POSIVIEW APPLICATION TECHNOLAGIES PRIVATE LIMITED
                  </Typography>
                </Typography>
                <Typography
                  sx={{
                    mb: 2,
                    textAlign: "center",
                  }}
                >
                  <Typography sx={{ fontWeight: 500 }}>
                    UPI Handle(UPA):
                  </Typography>
                  <Typography
                    component="span"
                    sx={{ fontWeight: 600, color: "#000" }}
                  >
                    ELEGANTPRIME@idfcbank
                  </Typography>
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{ backgroundColor: "#9998FF", padding: "0 !important" }}
              >
                <Typography
                  sx={{
                    fontWeight: 500,
                    color: "#000",
                    textAlign: "center",
                    padding: "10px 0",
                  }}
                >
                  Scan and Pay With using apps listed below details
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Modal>
    );
}

export default DisplayQrScanModal;